import styled from 'styled-components';

const StylesErrorFallbackConatiner = styled.div`
.se-error-fallback-component {
    height: 100vh;
    width: 100%;
}
`;
export default StylesErrorFallbackConatiner;
